import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { SetCardLimitStackRoutes, SetCardLimitStackScreenProps } from './type';
import { ConfirmationScreen } from './Confirmation.screen';
import { ConfirmationNativeScreen } from './ConfirmationNative.screen';

export const SetCardLimitConfirmation: React.FC<SetCardLimitStackScreenProps<SetCardLimitStackRoutes.Confirmation>> = ({
  navigation,
  route
}) => {
  const { onLayout, data, account, tab, dailyLimitType, record, func, onReturnData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <ConfirmationNativeScreen
        onClose={onGoBack}
        onLayout={onLayout}
        data={data}
        account={account}
        tab={tab}
        dailyLimitType={dailyLimitType}
        record={record}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
      />
    );
  }

  return (
    <ConfirmationScreen
      onClose={closeModal}
      onLayout={onLayout}
      data={data}
      account={account}
      tab={tab}
      dailyLimitType={dailyLimitType}
      record={record}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
    />
  );
};
